import { DocLayout } from './DocLayout';

export default function DocEchipe() {
  return (
    <DocLayout title="Echipe">
      <h2>Prezentare generală</h2>
      <p>
        Echipele sunt grupuri organizatorice pentru utilizatorii staff. Funcționalitate disponibilă doar superadminilor.
      </p>

      <h2>Gestionare echipe</h2>
      <ul>
        <li><strong>Creare</strong> — definește un nume și o culoare pentru echipă.</li>
        <li><strong>Editare</strong> — modifică numele sau culoarea.</li>
        <li><strong>Ștergere</strong> — elimină echipa (nu afectează utilizatorii).</li>
      </ul>

      <h2>Asociere cu utilizatori</h2>
      <p>
        Utilizatorii staff sunt asociați cu echipe din pagina de gestionare a utilizatorilor.
        Un utilizator poate face parte din mai multe echipe.
        Echipele sunt afișate ca badge-uri colorate lângă numele utilizatorului.
      </p>
    </DocLayout>
  );
}
